import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  RenderingProps,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from 'src/shared/shared.types';

export type C30IconCTASimplifiedProps = RenderingProps<
  C30IconCTASimplifiedFields,
  C30IconCTASimplifiedRenderingParmas
>;

export type C30IconCTASimplifiedFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
};

export type C30IconCTASimplifiedRenderingParmas = {
  HeadlineTag?: string;
  NumberOfColumns?: string;
  MobileBehavior?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
